export { Colors } from './Colors';

export const heightOfNavbar = '60px';
